import { __decorate, __extends } from "tslib";
import { FoundationProperty, upgradeProperty, coerceBoolean } from '@tyler-components-web/core';
import { BASE_SELECT_CONSTANTS } from './base-select-constants';
import { ListDropdownAware } from '../../list-dropdown/list-dropdown-aware';
var BaseSelectComponent = /** @class */ (function (_super) {
    __extends(BaseSelectComponent, _super);
    function BaseSelectComponent() {
        return _super.call(this) || this;
    }
    BaseSelectComponent.prototype.initializedCallback = function () {
        _super.prototype.initializedCallback.call(this);
        upgradeProperty(this, 'value');
        upgradeProperty(this, 'selectedIndex');
        upgradeProperty(this, 'options');
        upgradeProperty(this, 'multiple');
        upgradeProperty(this, 'open');
        upgradeProperty(this, 'optionBuilder');
        upgradeProperty(this, 'selectedTextBuilder');
        upgradeProperty(this, 'beforeValueChange');
        upgradeProperty(this, 'dialogWidthThreshold');
        upgradeProperty(this, 'selectOnBlur');
    };
    BaseSelectComponent.prototype.attributeChangedCallback = function (name, oldValue, newValue) {
        _super.prototype.attributeChangedCallback.call(this, name, oldValue, newValue);
        switch (name) {
            case BASE_SELECT_CONSTANTS.attributes.MULTIPLE:
                this.multiple = this.hasAttribute(BASE_SELECT_CONSTANTS.attributes.MULTIPLE);
                break;
            case BASE_SELECT_CONSTANTS.attributes.VALUE:
                this.value = newValue;
                break;
            case BASE_SELECT_CONSTANTS.attributes.SELECT_ON_BLUR:
                this.selectOnBlur = coerceBoolean(newValue);
                break;
        }
    };
    BaseSelectComponent.prototype.appendOptions = function (options) {
        this._foundation.appendOptions(options);
    };
    BaseSelectComponent.prototype.selectAll = function () {
        this._foundation.selectAll();
    };
    BaseSelectComponent.prototype.deselectAll = function () {
        this._foundation.deselectAll();
    };
    BaseSelectComponent.prototype.connectedCallback = function () {
        this._foundation.initialize();
    };
    BaseSelectComponent.prototype.disconnectedCallback = function () {
        this._foundation.disconnect();
    };
    __decorate([
        FoundationProperty()
    ], BaseSelectComponent.prototype, "value", void 0);
    __decorate([
        FoundationProperty()
    ], BaseSelectComponent.prototype, "selectedIndex", void 0);
    __decorate([
        FoundationProperty()
    ], BaseSelectComponent.prototype, "options", void 0);
    __decorate([
        FoundationProperty()
    ], BaseSelectComponent.prototype, "multiple", void 0);
    __decorate([
        FoundationProperty()
    ], BaseSelectComponent.prototype, "open", void 0);
    __decorate([
        FoundationProperty({ get: false })
    ], BaseSelectComponent.prototype, "optionBuilder", void 0);
    __decorate([
        FoundationProperty({ get: false })
    ], BaseSelectComponent.prototype, "selectedTextBuilder", void 0);
    __decorate([
        FoundationProperty({ get: false })
    ], BaseSelectComponent.prototype, "beforeValueChange", void 0);
    __decorate([
        FoundationProperty()
    ], BaseSelectComponent.prototype, "dialogWidthThreshold", void 0);
    __decorate([
        FoundationProperty()
    ], BaseSelectComponent.prototype, "selectOnBlur", void 0);
    __decorate([
        FoundationProperty({ set: false })
    ], BaseSelectComponent.prototype, "popupElement", void 0);
    return BaseSelectComponent;
}(ListDropdownAware));
export { BaseSelectComponent };
